export default __webpack_public_path__ + "static/media/icon.ca382c14.png";